import { render, staticRenderFns } from "./Consumidores.vue?vue&type=template&id=2030dcae"
import script from "./Consumidores.vue?vue&type=script&lang=js"
export * from "./Consumidores.vue?vue&type=script&lang=js"
import style0 from "./Consumidores.vue?vue&type=style&index=0&id=2030dcae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports